export default "https://cdn-static-staging.gokick.com/assets/8452366be4f72804419de7522b15e5b20c0c8dd8/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";